import { fromPromise } from 'xstate';

import {
  type FeaturedUpsellProduct,
  type FetchProductInput,
} from './bag-featured-upsell.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const fetchProduct = fromPromise<FeaturedUpsellProduct | undefined, FetchProductInput>(
  async () => {
    throw new Error('`fetchProduct` actor is not provided.');
  },
);
